import { render, staticRenderFns } from "./AddExamine.vue?vue&type=template&id=13bab47e"
import script from "./AddExamine.vue?vue&type=script&lang=ts"
export * from "./AddExamine.vue?vue&type=script&lang=ts"
import style0 from "./AddExamine.vue?vue&type=style&index=0&id=13bab47e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports